export namespace SprintViewUsageTelemetryConstants {
    export const SWITCH_SPRINT = "SprintsHub_SwitchSprint";
    export const CLICK_TRYOUT_ANALYTICSPIVOT = "SprintsHub_TryOutAnalyticsPivot";
    export const NAVIGATE_TO_DIRECTORY = "SprintsHub_NavigateToDirectory";
    export const PLAN_SPRINT = "SprintsHub_PlanSprintOnZeroDayExperience";
    export const SEARCH_SPRINT = "SprintsHub_SearchSprint";
    export const SPRINT_START_LOADCONTENTVIEW = "SprintsHub_Start_LoadContentView";
    export const SPRINT_START_RELOADHEADER = "SprintsHub_Start_ReLoadHeader";
    export const SPRINT_END_RELOADHEADER = "SprintsHub_End_ReLoadHeader";
    export const RIGHT_PANEL_CHANGED = "SprintsHub_RightPanelChanged";
    export const RIGHT_PANEL_STATE = "SprintsHub_RightPanelState";
    export const SEARCH_TEAM = "SprintsHub_SearchTeam";
    export const WORK_DETAILS_WORK_ITEMS_DROPPED = "SprintsHub_WorkDetailsWorkItemsDropped";
    export const HUB_TILE_STATE = "SprintsHub_HubTileState";
    export const PARENT_COLUMN_ADDED = "SprintsHub_Backlog_ParentColumn_Added";
    export const PARENT_COLUMN_REMOVED = "SprintsHub_Backlog_ParentColumn_Removed";
}